var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    { staticClass: "w-header", class: _vm.headerName },
    [
      _c("div", { staticClass: "w-header-eye" }, [
        _c("img", {
          staticClass: "w-header-eye-img",
          attrs: { src: _vm.logo, height: "100%" },
          on: { click: _vm.goHome }
        })
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "w-header-info" }, [
        _c("div", { staticClass: "w-header-index" }, [
          _c(
            "span",
            { staticClass: "w-header-info-text1", on: { click: _vm.goIndex } },
            [_vm._v("免费发活动")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "w-header-account" }, [
          _c("span", { staticClass: "w-header-info-hello" }, [
            _vm._v(" 你好"),
            _vm.user && _vm.user !== "null"
              ? _c("span", [_vm._v("，")])
              : _vm._e(),
            _vm.user && _vm.user !== "null"
              ? _c(
                  "span",
                  {
                    staticClass: "w-header-info-text",
                    on: { click: _vm.goAccount }
                  },
                  [_vm._v(_vm._s(_vm.user))]
                )
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "w-header-info-text w-header-signout",
            on: { click: _vm.logout }
          },
          [_vm._v("退出")]
        )
      ]),
      _vm._v(" "),
      _c("w-mask", {
        attrs: { isMask: _vm.isMask },
        on: {
          closeMask: _vm.closeMask,
          goEvente: _vm.eventeFun,
          goLight: _vm.lightFun
        }
      }),
      _vm._v(" "),
      _c(
        "w-modal",
        {
          attrs: { show: _vm.modalShow, tip: true, title: "退出账号" },
          on: {
            close: _vm.modalClose,
            cancel: _vm.modalCancel,
            ok: _vm.modalOk
          }
        },
        [
          _c("div", { attrs: { slot: "modal-main" }, slot: "modal-main" }, [
            _vm._v("确定要退出账号？")
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "w-header-controller" }, [
      _c("span", { staticClass: "w-header-controller-text" }, [
        _vm._v("活动主办自己的系统")
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-61525da3", { render: render, staticRenderFns: staticRenderFns })
  }
}